import { useCallback, useState } from 'react';

import { evolutionInsightsState } from '@/states/evolution-insights.state';
import { CompareKpis } from '@/types/compare-offers';
import { useSetAtom } from 'jotai';

import {
  GetDealKpisQueryVariables,
  useGetDealKpisLazyQuery,
} from '../graphql/generated/graphql';

export const useCompareKpis = () => {
  const [executeQuery, { loading, error }] = useGetDealKpisLazyQuery();
  const setEvolutionInsights = useSetAtom(evolutionInsightsState);

  const [kpisData, setKpisData] = useState<CompareKpis | null>(null);

  const fetchKpis = async (variables: GetDealKpisQueryVariables) => {
    try {
      const { data } = await executeQuery({ variables });
      if (!data?.dealKpis) {
        throw new Error();
      }

      const insights = data.dealKpis.evolutionInsightsV2;
      const kpis = {
        currentDealKpis: data.dealKpis.currentDealKpis,
        previousCampaignKpis: data.dealKpis.previousCampaignKpis ?? {
          avgChoosePrice: null,
          avgDiscount: null,
          avgMargin: null,
          productsCount: 0,
          totalPotential: null,
          totalStock: 0,
        },
        evolutionInsightsV2: insights,
      };

      setKpisData(kpis);
      setEvolutionInsights(insights ?? null);
    } catch (err) {
      console.error('Error fetching previous sale KPIs:', err);
      setEvolutionInsights(null);
    }
  };

  const reset = useCallback(() => {
    setKpisData(null);
    setEvolutionInsights(null);
  }, [setEvolutionInsights]);

  return {
    fetchKpis,
    kpisData,
    loading,
    error,
    reset,
  };
};
